// /no-access — non-admin authenticated landing.
// -----------------------------------------------------------------
// Per dispatch m3-2-auth-rules-listener.md § 6.11.

import { createFileRoute } from '@tanstack/react-router';

import { NoAccessPage } from '@/auth/NoAccessPage';

export const Route = createFileRoute('/no-access')({
  component: NoAccessPage,
});
